<template>
  <div class="modal fade" id="storage-visitor" data-backdrop="true" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title d-inline">Storage & Visitors</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="loader"></div>
          <div v-else>
            <section v-if="diskSpace.length > 0">
              <h5>Storage</h5>
              <div class="progress" style="height: 20px;" v-for="(space, index) in diskSpace" :key="space + '_' + index" v-if="space">
                <div :class="{'progress-bar': true, 'bg-danger': space > 80}" :style="{'width': space+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                  {{space}}%
                </div>
              </div>
            </section>
            <section v-if="allVisitors.length > 0">
              <h5>Visitors</h5>
              <div v-for="(visitors, index) in allVisitors" :key="visitors + '_' + index" class="progress" style="height: 20px;">
                <div :class="{'progress-bar': true, 'bg-danger': visitors > 80}" :style="{'width': visitors+'%'}" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                  {{ visitors }}%
                </div>
              </div>
            </section>
            <section v-if="!diskSpace.length && !allVisitors.length">
              <p>No account Found for this user</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {db} from "@/firebase/init";
  import _ from 'lodash';
  export default {
    name: "detailsModal",
    data () {
      return {
        loading: false,
        diskSpace: [],
        allVisitors: [],
      }
    },
    computed: {
      plans() {
        return this.$store.getters["plan/list"];
      }
    },
    methods: {
      async load (docId) {
        console.log('asdadsasd ')
        $('#storage-visitor').modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
        this.loading = true

        let diskSpace = [];
        let allVisitors = [];

        const accountRef = await db
          .collection("hostingAccounts").doc(docId)
          .get()

        const accounts = accountRef.data().accounts;

        accounts.map((account) => {
          let plan = this.plans.filter((item) => item.name == account.planName);
          let fullDiskSpace = account.fullDiskSpace;
          if (fullDiskSpace !== undefined) {
            try {
              if (Object.keys(fullDiskSpace).length == 3) {
                if (plan.length) {
                  let size = 1;
                  if (fullDiskSpace[2].value == 'G') {
                    size *= 1024;
                  }
                  let maxStorageSize = parseFloat(plan[0].maxStorageSize);
                  if(account.maxStorageSize !== undefined){
                    maxStorageSize = account.maxStorageSize;
                  }
                  let maxStorageSizeMb = maxStorageSize * 1024;
                  let diskSpaceMb = parseFloat(fullDiskSpace[2].size) * size;


                  let storage = Math.ceil((diskSpaceMb/maxStorageSizeMb) * 100);
                  diskSpace.push(storage);
                }
              }
            } catch (e) {
              console.error(e);
            }
          }

          let visitors = (plan.length && account.allVisitors) ? Math.ceil((account.allVisitors / account.maxVisitors) * 100) : 0;
          if (isNaN(visitors)) {
            visitors = 0;
          }
          allVisitors.push(visitors);
        });

        this.diskSpace =  _.sortBy(diskSpace).reverse();
        this.allVisitors = _.sortBy(allVisitors).reverse();
        this.loading = false
      }
    }
  }
</script>

<style scoped>

</style>
